import { useEffect, useState } from 'react';

import { Grid } from "@material-ui/core";
import BackupIcon from '@mui/icons-material/Backup';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

import 'dayjs/locale/en-gb';

import { Box } from "@material-ui/core";
import ReplyIcon from '@mui/icons-material/Reply';
import Backdrop from '@mui/material/Backdrop';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';

import 'dayjs/locale/en-gb';


import Swal from 'sweetalert2';



const PdfUpload = ({submitValue,setSubmitValue}) => {

  useEffect(() => {
    if(submitValue.p_id === "" || !submitValue.hasOwnProperty('p_id')){localStorage.removeItem("savedPDF");localStorage.removeItem("savedPDFName");}
    else{
      const saved = localStorage.getItem("savedPDF");
      const fileName = localStorage.getItem("savedPDFName");
    
    if (saved) {
      const file = base64ToFile(saved, fileName);
      setFileStore(file);
      setFileURL(URL.createObjectURL(file));
      setSubmitValue( prevValues => {
        return { ...prevValues,folio_bo_file: file}
      })
    }
    }
    
  }, []);
  
//  console.log(submitValue);
  
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60%',
        height:"80vh",
        bgcolor: 'background.paper',
        border: '2px solid #eee',
        boxShadow: '2px 2px 2px 2px #eee',
        borderRadius:"10px",
        p: 4
      };
     const [fileURL,setFileURL] = useState("");
     const [fileStore,setFileStore] = useState();
     const [open,setOpen] = useState(false);
     const fileToBase64 =  (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
      const base64ToFile = (base64String, fileName = "file.pdf") => {
        const arr = base64String.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
      
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
      // console.log([u8arr])
        return new File([u8arr], fileName, { type: mime });
      };
    const handleFileUploadPDF = async (event) => {
          
        const file = event.target.files[0];
        
        if(file && file.type === "application/pdf")
          {
            setFileURL(URL.createObjectURL(file));
            if ( file.type === "application/pdf" ) 
              {
                if((file.size/1024)>1024)
                    {
                      Swal.fire({
                        icon: 'warning',
                        title: 'The File is greater than 1 MB! ',
                        text:"Please upload a file smaller than 1 MB.",
                        showConfirmButton: true,
                        customClass: {
                            container: 'my-swal'
                          },
                        // timer: 3000
                      })
                      return;
                    }
                    else{
    
                        
                        const base64 = await fileToBase64(file);
                        setFileStore(file);
                        localStorage.setItem("savedPDF", base64);
                        localStorage.setItem("savedPDFName",file.name)
                        setSubmitValue( prevValues => {
                            return { ...prevValues,folio_bo_file: file}
                          })
                        setOpen(true); 
                    }
          }      
       
           
        }
        else
        {
          Swal.fire({
            icon: 'warning',
            title: 'File does not support. You must use .pdf ',
            showConfirmButton: true,
            customClass: {
                container: 'my-swal'
              },
            // timer: 3000
          })
          return;
        }
        event.target.value = null; // Reset the input value to allow re-uploading the same file
      };
     

  const handleOpenPreview = () =>{
      return(
        <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={()=>{setOpen(false);} }
        closeAfterTransition
        BackdropComponent={Backdrop}
        slots={{ backdrop: Backdrop }}
        slotProps={{
        backdrop: {
            timeout: 500,
        }}}
       style={{overflow: "auto", display:"flex",justifyContent:"center",alignItems:"center", textAlign:"center", borderRadius:"10px"
       }}
       >
        <Fade in={open}>
        <Box sx={style} style={{textAlign:"center",width:"80%",height:"80vh"}} >
            <h3>PDF PREVIEWER </h3>
            <Box className="form-control" style={{textAlign:"center",height:"90%"}}>
                {fileURL ? (
                    // <div
                    //     style={{
                    //         border: '1px solid rgba(0, 0, 0, 0.3)',
                    //         height: '100%',
                    //     }}
                    // >
                    //     <Viewer fileUrl={fileURL} />
                    // </div>
                    <iframe
                        src={fileURL}
                        width="100%"
                        height="100%"
                        title="PDF Viewer"
                      />
                ) : (
                    <div
                        style={{
                            alignItems: 'center',
                            border: '2px dashed rgba(0, 0, 0, .3)',
                            display: 'flex',
                            fontSize: '2rem',
                            height: '100%',
                            justifyContent: 'center',
                            width: '100%',
                        
                        }}
                    >
                        Please upload a PDF file to preview.
                    </div>
                )}
                
                <Button type="button" onClick={()=>{setOpen(false);}} variant="contained" color="info" style={{color:"white"}}><ReplyIcon/> Close</Button>
                </Box>
        </Box>
        </Fade>
    </Modal>
      )

      
    }
  return (
    <div onDragOver={(e) => e.preventDefault()}
      onDrop={ async (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file && file.type === "application/pdf") {
          if((file.size/1024)>1024)
          {
            Swal.fire({
              icon: 'warning',
              title: 'The File is greater than 1 MB! ',
              text:"Please upload a file smaller than 1 MB.",
              showConfirmButton: true,
              customClass: {
                  container: 'my-swal'
                },
            })
            return;
          }
          else{
            const base64 = await fileToBase64(file);
            setFileStore(file);
            localStorage.setItem("savedPDF", base64);
            localStorage.setItem("savedPDFName",file.name)
            setSubmitValue( prevValues => {
              return { ...prevValues,folio_bo_file: file}
            })
            setFileURL(URL.createObjectURL(file));
            setOpen(true);
          }
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'File does not support. You must use .pdf ',
            showConfirmButton: true,
            customClass: {
                container: 'my-swal'
              },
          })
        }
      }}
      style={{
        border: "2px dashed slateblue",
        padding: "20px",
        borderRadius: "10px",
        textAlign: "center",
        backgroundColor: "#f5f5f5",
      }}
      >
        <h4 style={{color:"slateblue"}}>Documents Upload ( Maximum Limit 1 MB ) : </h4>
        <p style={{color:"slateblue"}}> Drag and Drop / Select PDF by clicking the button</p>
                      <Grid container spacing={2} style={{padding:"20px"}} >
                      <Grid item lg={6} md={6} sm={12} xs={12} for="pdfupload" > <label
                                        for="pdfupload"
                                        style={{ color: "black", border:"1px solid slateblue" }}
                                        className="btn btn-warning btn-lg"
                                        ><BackupIcon style={{fill:'black'}} /> Upload PDF File</label>
                                        <input
                                          id="pdfupload"
                                          name="folio_bo_file"
                                          type="file"
                                          accept="application/pdf"
                                          onChange={(e)=>{
                                              handleFileUploadPDF(e);
                                          }}
                                          style={{ display: "none",visibility:"none" }}
                                        />
                                        {fileStore ? 
                                        <>
                                        <button className="btn btn-danger btn-lg" type="button" style={{color:"white", border:"2px solid white", marginLeft:"2px"}}
                                        onClick={()=>{
                                          Swal.fire({
                                            icon: 'question',
                                            title: 'Are you sure about removing the file selected?',
                                            showConfirmButton: true,
                                            confirmButtonText: 'Yes',
                                            showCancelButton: true,
                                            cancelButtonText: "No",
                                            customClass: {
                                                container: 'my-swal'
                                              },
                                          }).then((res)=>{
                                            if(res.isConfirmed)
                                            {
                                              setFileStore("");
                                              setFileURL("");
                                              setSubmitValue( prevValues => {
                                                return { ...prevValues,folio_bo_file: ""}
                                              });
                                              localStorage.removeItem("savedPDF");
                                              localStorage.removeItem("savedPDFName");
                                            }
                                          })
                                        }}
                                        >X</button>
                                        <h6>{fileStore?.name}</h6> 
                                        <h6>{Math.round(fileStore?.size/1024)} KB </h6> 
                                        
                                        </>
                                        : null}
                                        </Grid>
                                        {open && handleOpenPreview()}
                                  <Grid item lg={6} md={6} sm={12} xs={12} >
                                  
                                    <button className="btn btn-primary btn-lg" type="button" style={{color:"white",border:"1px solid white"}} onClick={()=>{setOpen(true);}}><RemoveRedEyeIcon/> Preview Uploaded PDF</button>
                                          {open && handleOpenPreview()}
                                  </Grid>
                                        </Grid>
    </div>
  )
}

export default PdfUpload